import React from "react";
import CustomPrintOutDelivery from "../../../../../partials/content/CustomPrintOutDelivery";
const DeliveryPrintOut = ({ delivery }) => {
  return (
    <React.Fragment>
      <CustomPrintOutDelivery deliveryID={delivery.ID} />
    </React.Fragment>
  );
};

export default DeliveryPrintOut;
